import React,{useState} from 'react';
import {PostFile} from '../../../services/servicesPostFile';
import Toastify from '../../Toastify/index';
import {Button,SpanButton} from '../../../pages/postEdit/stylePostEdit'
import {URLIMG} from '../../../helpers/constantes'
export default function InputFile ({name,mudaImg,imagem,campo,load,concluido}) {
    //configuração do toastify
    const [statusToastify, setStatusToastify]=useState('');
    const customId  = 'custom-id-yes';
    const Sucess = (Mensagem) => Toastify.success(Mensagem,{toastId:customId} );
    const Error = () => Toastify.error('Erro ao carregar a imagem',{toastId:customId});

    //fim configuração do toastify

    let hiddenFileInput = React.useRef(null);

    function handleClick (event){
        event.preventDefault();
        hiddenFileInput.current.click();
    };
    async function handleChange(event){
        event.preventDefault();
        let reader = new FileReader();
        let fileUploaded = event.target.files[0];

        if (!fileUploaded)
        return
        reader.readAsDataURL(fileUploaded)
        reader.onloadend = async ()=>{
            try {
                concluido(!load)
                const NomeArquivo = await PostFile([fileUploaded,reader.result]);
                if (NomeArquivo.resposta){
                    if (typeof(campo)!= 'undefined'){
                        imagem[campo] = NomeArquivo.arquivo;
                        concluido(load);
                        mudaImg({...imagem,fileUploaded,NomeArquivo:NomeArquivo.arquivo});
                        Sucess('Foto Carregada');
                    }else{
                        concluido(load);
                        // debugger
                        mudaImg({...imagem,Image1:URLIMG+NomeArquivo.arquivo.split('/')[NomeArquivo.arquivo.split('/').length - 1],fileUploaded,NomeArquivo:NomeArquivo.arquivo})
                        Sucess('Foto Carregada');
                    }
                }else{
                    Error();
                    concluido(load);
                }
            } catch (error) {
                concluido(load);
                Error();
                console.log(error);
            }
        }
    }
return(<div style={{marginBottom:'20px',display:'flex',height: 'inherit',justifyContent: 'center'}}>
    <Button onClick={(event)=>handleClick(event)}>
        <SpanButton>{name?name:'Trocar imagem'}</SpanButton>
    </Button>
    <input type='file' accept="image/*" ref={hiddenFileInput} onChange={handleChange} style={{display:'none'}} />
</div>)

}
